// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__-bXwD","footer":"ModalFilter_footer__2Adbd"};